import { Component, OnInit } from '@angular/core';
import {
    ActivatedRoute,
    GuardsCheckEnd,
    GuardsCheckStart,
    NavigationCancel,
    NavigationEnd,
    Router,
    RouterEvent,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { PiwikService } from './shared/services/piwik';
import { BrowserUtil } from './shared/library/px-ui/px-forms/utils';
import { Routes } from './core/routes/routes';
import { filter, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RoutingService } from './core/services/routing.service';
import { OidcService } from './shared/services/oidc/oidc.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    isLoading$: Observable<boolean>;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private title: Title,
        private matomoService: PiwikService,
        private _routerService: RoutingService,
        private _oidcService: OidcService
    ) {
        this.setTitleAndMatomoTrackOnChange$.subscribe();
    }

    get setTitleAndMatomoTrackOnChange$() {
        const getFirstChild = (route) => {
            while (route.firstChild) {
                route = route.firstChild;
            }
            return route;
        };
        return this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            tap((event) => this.extractUrlAndSetTitle(event)),
            map(() => this.activatedRoute),
            map(getFirstChild),
            filter((route) => route.outlet === 'primary'),
            tap(() => this.matomoService.trackPageVisit(document.title))
        );
    }

    ngOnInit(): void {
        this.isLoading$ = this.__isGuardActive$();
        this._oidcService.initOidcWebcomponent();
    }

    extractUrlAndSetTitle(event) {
        const url = BrowserUtil.extractUrlFromQueryParam(event.url);
        const foundPage = Object.keys(Routes)
            .map((key) => Routes[key])
            .find((item) => BrowserUtil.contains(url, item.path));
        if (foundPage) {
            this.title.setTitle(`Online-Dialog Bezügestellen: ${foundPage.title}`);
        }
    }

    private __isGuardActive$(): Observable<boolean> {
        return this.router.events.pipe(filter(this._isGuardEvent), map(this._isGuardActive));
    }

    private _isGuardEvent(event: RouterEvent): boolean {
        return (
            event instanceof GuardsCheckStart || event instanceof GuardsCheckEnd || event instanceof NavigationCancel
        );
    }

    private _isGuardActive(event: GuardsCheckStart | GuardsCheckEnd | NavigationCancel): boolean {
        if (event instanceof GuardsCheckStart) {
            return true;
        }
        if (event instanceof GuardsCheckEnd || event instanceof NavigationCancel) {
            return false;
        }
    }
}
